import HeaderItem from './HeaderItem';
import Logo from '../../../assets/img/logo.png';

export default function Header() {
  return (
    <>
      <header>
        <div id="fixed-header-light" className="header-output fixed-header">
          <div className="header-output">
            <div className="container container_header header-in">
              <div className="position-relative">
                <div className="row">
                  <div className="col-lg-2 col-md-12">
                    <div className="logo_section">
                      <a id="logo" href="index.php" className="d-inline-block margin-tb-15px">
                        <img src={Logo} alt="Navira Live" />
                      </a>
                      <a className="mobile-toggle padding-15px">
                        <i className="fa fa-bars" />
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-10 col-md-12 position-inherit">
                    <HeaderItem />
                  </div>
                  {/* <div className="col-lg-1 col-md-12  d-none d-lg-block text-right">
                    <a
                      className="hideonadmissionfrm"
                      href="#"
                      className="top-button black_bg_btn "
                    ></a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
